import React, { Fragment, useState, useEffect, useCallback } from 'react';
import MainLayout from '../components/layouts/MainLayout';
import BookingDetail from '../components/views/bookings/BookingDetail';
import Spin from '../components/Spin';
import countryInfo from '../assets/countries.json';
import * as api from '../api';

const BookingDetailContainer = ({
  history,
  match,
}) => {
  const bookingId = match.params.id;
  const countryInfoList = Object.values(countryInfo);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ countryNumber, setCountryNumber ] = useState('82');
  const [ selectedBuildingName, setSelectedBuildingName ] = useState('');
  const [ selectedRoomName, setSelectedRoomName ] = useState('');
  const [ bookingUpdateItem, setBookingUpdateItem ] = useState({
    userName: '',
    phoneNumber: '',
    desc: '',
    checkinAt: '',
    checkoutAt: '',
    createdAt: '',
    updatedAt: '',
  });
  const [ userkeyListItems, setUserkeyListItems ] = useState([]);

  const moveToListPage = () => {
    history.push('/booking');
  };

  const selectBooking = useCallback(async () => {
    try {
      const res = await api.selectBooking({bookingId});
      setBookingUpdateItem({
        userName: res.data.user.name,
        phoneNumber: res.data.user.phone_number ? res.data.user.phone_number.replace(/([0-9]*)(\d{10})/, '0$2'):'',
        desc: res.data.desc || '',
        checkinAt: new Date(res.data.checkin_at),
        checkoutAt: new Date(res.data.checkout_at),
        createdAt: res.data.created_at,
        updatedAt: res.data.updated_at,
      });
      setUserkeyListItems([...res.data.cards, ...res.data.pincodes, ...res.data.mobilekeys]);
      setSelectedBuildingName(res.data.building.name);
      setSelectedRoomName(res.data.room.name);
      if (res.data.user.phone_number) setCountryNumber(res.data.user.phone_number.replace(/([0-9]*)(\d{10})/, '$1'));
    } catch (error) {
      throw error;
    }
  }, [bookingId]);

  const updateBooking = async () => {
    try {
      setIsLoading(true);
      const reqNum = countryNumber + Number.parseInt(bookingUpdateItem.phoneNumber);
      await api.updateBooking({bookingId, ...bookingUpdateItem, phoneNumber:reqNum});
    } catch (error) {
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    try {
      if (bookingId) selectBooking();
    } catch (error) {
      throw error;
    }
  }, [bookingId, selectBooking]);

  return (
    <Fragment>
      <Spin isSpin={isLoading}/>
      <MainLayout
        history={history}
        refresh={() => moveToListPage()}
        ContentBody={(
          <BookingDetail
            bookingId={bookingId}
            countryInfoList={countryInfoList}
            countryNumber={countryNumber}
            selectedBuildingName={selectedBuildingName}
            selectedRoomName={selectedRoomName}
            bookingUpdateItem={bookingUpdateItem}
            userkeyListItems={userkeyListItems}
            setCountryNumber={setCountryNumber}
            setBookingUpdateItem={setBookingUpdateItem}
            selectBookingApi={selectBooking}
            updateBookingApi={updateBooking}
            moveToListPage={moveToListPage}
            history={history}
          />
        )}
      />
    </Fragment>
  );
};

export default BookingDetailContainer;